import { render, staticRenderFns } from "./DraftDeleteConfirmation.vue?vue&type=template&id=57aa3104&scoped=true&"
import script from "./DraftDeleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./DraftDeleteConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DraftDeleteConfirmation.vue?vue&type=style&index=0&id=57aa3104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aa3104",
  null
  
)

export default component.exports